import MobileDetect from 'mobile-detect'
import CatalogPage from '../src/components/mobilePages/catalog/CatalogPage/CatalogPage'
import { createGSSP, pageStarted } from 'src/pages/shared/bindings'

export default function CatalogIndex() {
    // eslint-disable-next-line react/react-in-jsx-scope
    return <CatalogPage />
}

export const getServerSideProps = createGSSP({
    pageEvent: pageStarted,
    async customize({ scope, context }) {
        const md = new MobileDetect(context.req.headers['user-agent'])
        return {
            props: {
                mobile: md.mobile()
            }
        }
    }
})
